// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"NumberVerificationLoader_modalBackdrop__96UlY","modalContent":"NumberVerificationLoader_modalContent__4tlTT"};